// import React, { useState, useEffect, useRef } from "react";
// import { Form, Button, Card, Row, Col, CardHeader } from "react-bootstrap";
// import { FaTrashAlt } from "react-icons/fa";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { BASE_URL } from "../BaseURL";
// import "../Assets/WebsiteCss/comStyle.css";

// const MAX_IMAGES = 3;

// const AddPropertyForm = () => {
//   const [title, setTitle] = useState("");
//   const [category, setCategory] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [description, setDescription] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [images, setImages] = useState([]);
//   const fileInputRefs = useRef([]);
//   const [metaData, setMetaData] = useState({
//     metaTitle: "",
//     metaKeywords: "",
//     metaDescription: "",
//   });

//   const [metaTouched, setMetaTouched] = useState({
//     title: false,
//     description: false,
//   });

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await axios.get(`${BASE_URL}/api/category/get-category`);
//         setCategories(res.data.data || res.data);
//       } catch {
//         toast.error("Failed to load categories");
//       }
//     };
//     fetchCategories();
//   }, []);
//   useEffect(() => {
//     setMetaData((prev) => ({
//       ...prev,
//       metaTitle: metaTouched.title ? prev.metaTitle : title,
//       metaDescription: metaTouched.description
//         ? prev.metaDescription
//         : description.substring(0, 160),
//     }));
//   }, [title, description]);

//   const handleImageChange = (file) => {
//     if (!file) return;

//     if (images.length >= MAX_IMAGES) {
//       toast.error(`Maximum ${MAX_IMAGES} images allowed`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setImages((prev) => [
//         ...prev,
//         {
//           id: crypto.randomUUID(),
//           file,
//           preview: reader.result,
//         },
//       ]);
//     };
//     reader.readAsDataURL(file);
//   };

//   const removeImage = (id) => {
//     setImages((prev) => prev.filter((img) => img.id !== id));
//   };

//   const resetFileInputs = () => {
//     fileInputRefs.current.forEach((input) => {
//       if (input) input.value = "";
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!title.trim()) return toast.error("Project title is required");
//     if (!category) return toast.error("Category is required");
//     if (!description.trim()) return toast.error("Description is required");
//     if (images.length === 0)
//       return toast.error("At least one image is required");

//     try {
//       setLoading(true);

//       const formData = new FormData();
//       formData.append("title", title);
//       formData.append("category", category);
//       formData.append("description", description);

//       images.forEach((img) => formData.append("images", img.file));

//       formData.append("metaTitle", metaData.metaTitle);
//       formData.append("metaKeywords", metaData.metaKeywords);
//       formData.append("metaDescription", metaData.metaDescription);

//       await axios.post(`${BASE_URL}/api/projects`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       toast.success("Project added successfully");

//       setTitle("");
//       setCategory("");
//       setDescription("");
//       setImages([]);
//       setMetaData({
//         metaTitle: "",
//         metaKeywords: "",
//         metaDescription: "",
//       });
//       setMetaTouched({ title: false, description: false });
//       resetFileInputs();
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Failed to add project");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Card className="my-4 border-0">
//       <CardHeader className="mainBGColor fw-bold text-white py-2 px-4">
//         Add Project
//       </CardHeader>

//       <Card.Body className="px-4">
//         <Form onSubmit={handleSubmit}>
//           {/* BASIC */}
//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Label>Project Title *</Form.Label>
//               <Form.Control
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//               />
//             </Col>

//             <Col md={6}>
//               <Form.Label>Category *</Form.Label>
//               <Form.Select
//                 value={category}
//                 onChange={(e) => setCategory(e.target.value)}
//               >
//                 <option value="">Select Category</option>
//                 {categories.map((cat) => (
//                   <option key={cat._id} value={cat._id}>
//                     {cat.categoryName}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Col>
//           </Row>

//           {/* DESCRIPTION */}
//           <Card className="mb-4 p-3 border">
//             <Form.Label className="fw-bold">Property Description *</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={6}
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//             />
//           </Card>

//           {/* IMAGES */}
//           <Card className="mb-4 p-3 border">
//             <Form.Label className="fw-bold">
//               Images (Max {MAX_IMAGES}) *
//             </Form.Label>

//             <Form.Control
//               type="file"
//               accept="image/*"
//               ref={(el) => (fileInputRefs.current[0] = el)}
//               onChange={(e) => handleImageChange(e.target.files[0])}
//             />

//             <Row className="mt-3">
//               {images.map((img) => (
//                 <Col md={4} key={img.id} className="mb-3">
//                   <div className="position-relative">
//                     <img
//                       src={img.preview}
//                       alt="preview"
//                       style={{
//                         width: "100%",
//                         height: "150px",
//                         objectFit: "cover",
//                         borderRadius: "6px",
//                       }}
//                     />
//                     <Button
//                       type="button"
//                       variant="light"
//                       size="sm"
//                       className="position-absolute top-0 end-0 m-2 border"
//                       onClick={() => removeImage(img.id)}
//                     >
//                       <FaTrashAlt size={12} />
//                     </Button>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </Card>

//           {/* META */}
//           <Col
//             md={12}
//             className="p-4 mt-4"
//             style={{ backgroundColor: "#f0f0f0", borderRadius: "8px" }}
//           >
//             <Row>
//               <Col md={12} className="mb-3">
//                 <Form.Label>Meta Title</Form.Label>
//                 <Form.Control
//                   value={metaData.metaTitle}
//                   onChange={(e) => {
//                     setMetaTouched({ ...metaTouched, title: true });
//                     setMetaData({ ...metaData, metaTitle: e.target.value });
//                   }}
//                   className="underline-input"
//                 />
//               </Col>

//               <Col md={6}>
//                 <Form.Label>Meta Keywords</Form.Label>
//                 <Form.Control
//                   value={metaData.metaKeywords}
//                   onChange={(e) =>
//                     setMetaData({
//                       ...metaData,
//                       metaKeywords: e.target.value,
//                     })
//                   }
//                   className="underline-input"
//                 />
//               </Col>

//               <Col md={6}>
//                 <Form.Label>Meta Description</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   value={metaData.metaDescription}
//                   onChange={(e) => {
//                     setMetaTouched({ ...metaTouched, description: true });
//                     setMetaData({
//                       ...metaData,
//                       metaDescription: e.target.value,
//                     });
//                   }}
//                   className="underline-input"
//                 />
//               </Col>
//             </Row>
//           </Col>

//           {/* SUBMIT */}
//           <div className="d-flex justify-content-end mt-4">
//             <Button type="submit" className="" disabled={loading}>
//               {loading ? "Submitting..." : "Submit Project"}
//             </Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// };

// export default AddPropertyForm;


import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Card, Row, Col, CardHeader, Badge } from "react-bootstrap";
import { FaTrashAlt, FaArrowLeft, FaArrowRight, FaPlus, FaBold, FaItalic, FaUnderline, FaListUl, FaListOl } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { BASE_URL } from "../BaseURL";
import { Editor, EditorState, RichUtils, convertToRaw, convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import "draft-js/dist/Draft.css";
import "../Assets/WebsiteCss/comStyle.css";

const MAX_IMAGES = 10;

const AddPropertyForm = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [newVideoUrl, setNewVideoUrl] = useState("");
  const fileInputRef = useRef(null);
  const editorRef = useRef(null);

  const [metaData, setMetaData] = useState({
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
  });

  const [metaTouched, setMetaTouched] = useState({
    title: false,
    description: false,
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/category/get-category`);
        setCategories(res.data.data || res.data);
      } catch {
        toast.error("Failed to load categories");
      }
    };
    fetchCategories();
  }, []);

  // Get plain text from editor
  const getPlainText = () => {
    return editorState.getCurrentContent().getPlainText();
  };

  // Get HTML from editor
  const getHTML = () => {
    const contentState = editorState.getCurrentContent();
    return stateToHTML(contentState);
  };

  useEffect(() => {
    const plainText = getPlainText().substring(0, 160);
    
    setMetaData((prev) => ({
      ...prev,
      metaTitle: metaTouched.title ? prev.metaTitle : title,
      metaDescription: metaTouched.description ? prev.metaDescription : plainText,
    }));
  }, [title, editorState, metaTouched]);

  // Draft.js toolbar handlers
  const handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return "handled";
    }
    return "not-handled";
  };

  const toggleInlineStyle = (style) => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, style));
  };

  const toggleBlockType = (blockType) => {
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };

  const focusEditor = () => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
  };

  // Check if style is active
  const currentInlineStyle = editorState.getCurrentInlineStyle();
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  // Image compression
  const compressImage = (file, maxWidth = 1920, maxHeight = 1080, quality = 0.8) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            if (width > height) {
              height = (height * maxWidth) / width;
              width = maxWidth;
            } else {
              width = (width * maxHeight) / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              resolve(new File([blob], file.name, { type: "image/jpeg" }));
            },
            "image/jpeg",
            quality
          );
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const handleImageChange = async (files) => {
    if (!files || files.length === 0) return;

    const newImages = Array.from(files).slice(0, MAX_IMAGES - images.length);

    if (images.length + newImages.length > MAX_IMAGES) {
      toast.error(`Maximum ${MAX_IMAGES} images allowed`);
      return;
    }

    for (const file of newImages) {
      try {
        const compressedFile = await compressImage(file);
        const reader = new FileReader();

        reader.onloadend = () => {
          setImages((prev) => [
            ...prev,
            {
              id: crypto.randomUUID(),
              file: compressedFile,
              preview: reader.result,
            },
          ]);
        };
        reader.readAsDataURL(compressedFile);
      } catch (err) {
        toast.error("Failed to process image");
      }
    }
  };

  const removeImage = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  const moveImage = (index, direction) => {
    const newImages = [...images];
    const targetIndex = direction === "left" ? index - 1 : index + 1;

    if (targetIndex < 0 || targetIndex >= newImages.length) return;

    [newImages[index], newImages[targetIndex]] = [
      newImages[targetIndex],
      newImages[index],
    ];
    setImages(newImages);
  };

  // Video handling
  const extractVideoId = (url) => {
    const match = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s]+)/
    );
    return match ? match[1] : null;
  };

  const addVideo = () => {
    if (!newVideoUrl.trim()) {
      toast.error("Please enter a video URL");
      return;
    }

    const videoId = extractVideoId(newVideoUrl);
    if (!videoId) {
      toast.error("Invalid YouTube URL");
      return;
    }

    const isDuplicate = videos.some((v) => v.id === videoId);
    if (isDuplicate) {
      toast.error("This video is already added");
      return;
    }

    setVideos((prev) => [
      ...prev,
      {
        id: videoId,
        url: newVideoUrl,
        thumbnail: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      },
    ]);
    setNewVideoUrl("");
    toast.success("Video added");
  };

  const removeVideo = (id) => {
    setVideos((prev) => prev.filter((v) => v.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const plainText = getPlainText();
    const htmlContent = getHTML();

    if (!title.trim()) return toast.error("Project title is required");
    if (!category) return toast.error("Category is required");
    if (!plainText.trim()) {
      return toast.error("Description is required");
    }
    if (images.length === 0) {
      return toast.error("At least one image is required");
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("title", title);
      formData.append("category", category);
      formData.append("description", htmlContent);

      images.forEach((img) => formData.append("images", img.file));
      videos.forEach((video) => formData.append("videos", video.url));

      formData.append("metaTitle", metaData.metaTitle);
      formData.append("metaKeywords", metaData.metaKeywords);
      formData.append("metaDescription", metaData.metaDescription);

      await axios.post(`${BASE_URL}/api/projects`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Project added successfully! 🎉");

      // Reset form
      setTitle("");
      setCategory("");
      setEditorState(EditorState.createEmpty());
      setImages([]);
      setVideos([]);
      setNewVideoUrl("");
      setMetaData({
        metaTitle: "",
        metaKeywords: "",
        metaDescription: "",
      });
      setMetaTouched({ title: false, description: false });
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to add project");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="my-4 border-0">
      <CardHeader className="mainBGColor fw-bold text-white py-2 px-4">
        Add Project
      </CardHeader>

      <Card.Body className="px-4">
        <Form onSubmit={handleSubmit}>
          {/* BASIC INFO */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>Project Title <span style={{ color: "red" }}>*</span></Form.Label>
              <Form.Control
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter project title"
              />
              <Form.Text className="text-muted">
                {title.length} characters
              </Form.Text>
            </Col>

            <Col md={6}>
              <Form.Label>Category <span style={{ color: "red" }}>*</span></Form.Label>
              <Form.Select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.categoryName}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {/* DESCRIPTION WITH DRAFT.JS */}
          <Card className="mb-4 p-3 border">
            <Form.Label className="fw-bold">Project Description <span style={{ color: "red" }}>*</span></Form.Label>
            
            {/* TOOLBAR */}
            <div className="draft-toolbar">
              <button
                type="button"
                className={`toolbar-btn ${currentInlineStyle.has("BOLD") ? "active" : ""}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleInlineStyle("BOLD");
                }}
                title="Bold"
              >
                <FaBold />
              </button>
              <button
                type="button"
                className={`toolbar-btn ${currentInlineStyle.has("ITALIC") ? "active" : ""}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleInlineStyle("ITALIC");
                }}
                title="Italic"
              >
                <FaItalic />
              </button>
              <button
                type="button"
                className={`toolbar-btn ${currentInlineStyle.has("UNDERLINE") ? "active" : ""}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleInlineStyle("UNDERLINE");
                }}
                title="Underline"
              >
                <FaUnderline />
              </button>
              <span className="toolbar-divider"></span>
              <button
                type="button"
                className={`toolbar-btn ${blockType === "unordered-list-item" ? "active" : ""}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleBlockType("unordered-list-item");
                }}
                title="Bullet List"
              >
                <FaListUl />
              </button>
              <button
                type="button"
                className={`toolbar-btn ${blockType === "ordered-list-item" ? "active" : ""}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  toggleBlockType("ordered-list-item");
                }}
                title="Numbered List"
              >
                <FaListOl />
              </button>
            </div>

            {/* EDITOR */}
            <div
              className="draft-editor-container"
              onClick={focusEditor}
            >
              <Editor
                ref={editorRef}
                editorState={editorState}
                onChange={setEditorState}
                handleKeyCommand={handleKeyCommand}
                placeholder="Write a detailed description of the project..."
              />
            </div>

            <Form.Text className="text-muted d-block mt-2">
              {getPlainText().length} characters
            </Form.Text>
          </Card>

          {/* IMAGES */}
          <Card className="mb-4 p-3 border">
            <Form.Label className="fw-bold">
              Images (Max {MAX_IMAGES}) <span style={{ color: "red" }}>*</span>{" "}
              <Badge bg="secondary">{images.length}/{MAX_IMAGES}</Badge>
            </Form.Label>

            <Form.Control
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => handleImageChange(e.target.files)}
            />

            <Row className="mt-3">
              {images.map((img, index) => (
                <Col md={4} key={img.id} className="mb-3">
                  <div className="position-relative">
                    <img
                      src={img.preview}
                      alt={`Preview ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                    {index === 0 && (
                      <Badge
                        bg="warning"
                        className="position-absolute top-0 start-0 m-2"
                      >
                        Primary
                      </Badge>
                    )}
                    <div className="position-absolute bottom-0 start-0 end-0 p-2 d-flex gap-1 justify-content-center">
                      {index > 0 && (
                        <Button
                          type="button"
                          variant="light"
                          size="sm"
                          onClick={() => moveImage(index, "left")}
                          title="Move left"
                        >
                          <FaArrowLeft size={12} />
                        </Button>
                      )}
                      {index < images.length - 1 && (
                        <Button
                          type="button"
                          variant="light"
                          size="sm"
                          onClick={() => moveImage(index, "right")}
                          title="Move right"
                        >
                          <FaArrowRight size={12} />
                        </Button>
                      )}
                      <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        onClick={() => removeImage(img.id)}
                        title="Delete"
                      >
                        <FaTrashAlt size={12} />
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>

          {/* VIDEOS */}
          <Card className="mb-4 p-3 border">
            <Form.Label className="fw-bold">
              YouTube Videos <Badge bg="secondary">{videos.length}</Badge>
            </Form.Label>
            
            <Row className="mb-3">
              <Col md={10}>
                <Form.Control
                  type="text"
                  value={newVideoUrl}
                  onChange={(e) => setNewVideoUrl(e.target.value)}
                  placeholder="Paste YouTube URL (e.g., https://www.youtube.com/watch?v=...)"
                />
              </Col>
              <Col md={2}>
                <Button
                  type="button"
                  variant="primary"
                  className="w-100"
                  onClick={addVideo}
                >
                  <FaPlus /> Add
                </Button>
              </Col>
            </Row>

            <Row>
              {videos.map((video, index) => (
                <Col md={4} key={video.id} className="mb-3">
                  <div className="position-relative">
                    <img
                      src={video.thumbnail}
                      alt={`Video ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                    <Badge
                      bg="dark"
                      className="position-absolute top-0 start-0 m-2"
                    >
                      Video {index + 1}
                    </Badge>
                    <Button
                      type="button"
                      variant="danger"
                      size="sm"
                      className="position-absolute top-0 end-0 m-2"
                      onClick={() => removeVideo(video.id)}
                    >
                      <FaTrashAlt size={12} />
                    </Button>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>

          {/* META */}
          <Card className="mb-4 p-4 border" style={{ backgroundColor: "#f8f9fa" }}>
            <h6 className="fw-bold mb-3">SEO & Meta Information</h6>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Label>Meta Title</Form.Label>
                <Form.Control
                  value={metaData.metaTitle}
                  onChange={(e) => {
                    setMetaTouched({ ...metaTouched, title: true });
                    setMetaData({ ...metaData, metaTitle: e.target.value });
                  }}
                  className="underline-input"
                  placeholder="SEO title for search engines"
                />
                <Form.Text className="text-muted">
                  {metaData.metaTitle.length}/60 characters (recommended)
                </Form.Text>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label>Meta Keywords</Form.Label>
                <Form.Control
                  value={metaData.metaKeywords}
                  onChange={(e) =>
                    setMetaData({
                      ...metaData,
                      metaKeywords: e.target.value,
                    })
                  }
                  className="underline-input"
                  placeholder="construction, residential, commercial"
                />
                <Form.Text className="text-muted">
                  Separate with commas
                </Form.Text>
              </Col>

              <Col md={6}>
                <Form.Label>Meta Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={metaData.metaDescription}
                  onChange={(e) => {
                    setMetaTouched({ ...metaTouched, description: true });
                    setMetaData({
                      ...metaData,
                      metaDescription: e.target.value,
                    });
                  }}
                  className="underline-input"
                  placeholder="Brief description for search results"
                />
                <Form.Text className="text-muted">
                  {metaData.metaDescription.length}/160 characters (recommended)
                </Form.Text>
              </Col>
            </Row>
          </Card>

          {/* SUBMIT */}
          <div className="d-flex justify-content-end mt-4">
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Submitting..." : "Create Project"}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddPropertyForm;